/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $RichText,
    RichTextStyleParams,
    RichTextProps,
    ExtendRichTextProps,
    getProp
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, Signal} from '@gongxigames/framework/core/fragments/store/Store';
import type {Override} from '@gongxigames/framework/lib/types/basic';

type RubyUITextStyles = 'BASE'
    | 'BASE_BOLD'
    | 'POPUP_HEADER'
    | 'PANEL_VAL_NAME'
    | 'PANEL_VAL'
    | 'SPIN_BTN_AUTOPLAY_LEFT'
    | 'SPIN_BTN_FS_LEFT'
    | 'WIN_PRESENTATION'
    | 'JURISDICTION_ZONE';

const BASE_STYLE: RichTextStyleParams = {
    fill: 0xffffff,
    // fontFamily: 'Roboto',
    fontFamily: 'Roboto',
    fontSize: 14*3,
    // fontWeight: 'bold',
    // fontFamily: 'Roboto-Regular',
    verticalAlign: 'center',
    align: 'center',
};

export const STYLES: Record<RubyUITextStyles, RichTextStyleParams> = {
    BASE: {
        ...BASE_STYLE,
    },
    BASE_BOLD: {
        ...BASE_STYLE,
        fontWeight: 'bold',
    },
    POPUP_HEADER: {
        ...BASE_STYLE,
        fontWeight: 'bold',
        fontSize: 16*3,
    },
    PANEL_VAL_NAME: {
        ...BASE_STYLE,
        fontSize: 9*3,
        fontWeight: 'bold',
        fill: 0xFFC000
    },
    PANEL_VAL: {
        ...BASE_STYLE,
        fontSize: 16*3,
        fontWeight: 'bold',
    },
    SPIN_BTN_AUTOPLAY_LEFT: {
        ...BASE_STYLE,
        fontSize: 24*3,
        fontWeight: 'bold',
        fill: 0xAD0000,
    },
    SPIN_BTN_FS_LEFT: {
        ...BASE_STYLE,
        fontSize: 48*3,
        fontWeight: 'bold',
        fill: 0xF2FFEB,
    },
    JURISDICTION_ZONE: {
        ...BASE_STYLE,
        fontSize: 9*3,
        fontWeight: 'bold',
    },
    WIN_PRESENTATION: {
        ...BASE_STYLE,
        fontSize: 48*3,
        fontWeight: 'bold',
        fill: 0xFFD200
    },
} as const;

export type RubyUITextBaseProps = {
    stylePreset: RubyUITextStyles;
};

export type RubyUITextPropsToOverride = ExtendRichTextProps<RubyUITextBaseProps>;
export type RubyUITextProps = Override<RubyUITextPropsToOverride, {
    style?: RichTextStyleParams | Signal<RichTextStyleParams>;
}>;

export const $RubyUIText: FC<RubyUITextProps> = (props) => {
    const styleProp = props.style;

    const style = Store.computed(() => {
        const stylePreset = getProp(props.stylePreset);
        const style = getProp(styleProp, {});

        return {
            ...STYLES[stylePreset],
            ...style
        };
    });

    return <$RichText {...props as RichTextProps} style={style}/>;
};